import { ENDPOINTS } from '@/lib/consts'
import type { ChatProvider } from '@/composables/chat/types'
import type { ZowieData } from '@/composables/chat/providers/zowie/types'

type ApiCall = (...args: unknown[]) => Promise<unknown>

export async function setupZowieChat (params: {
  apiCall: ApiCall
  businessId: number
}): Promise<ChatProvider> {
  const res = (await params.apiCall({
    method: 'POST',
    url: ENDPOINTS.ZOWIE_JWT,
    data: {
      business_id: params.businessId,
    },
    params: {
      new_zowie: 1,
    },
  })) as { data: ZowieData }

  const Zowie = await import('@/composables/chat/providers/zowie/index.ts')
  Zowie.createZowie({ data: res.data })
  return Zowie.useZowie()
}
